<template>
  <div class="detalle-container-premium">
    <ProgressBar v-if="loader" mode="indeterminate" style="height: 3px;" />
    
    <!-- Accordion de detalles -->
    <Accordion :multiple="true" class="detalles-accordion-premium">
      <AccordionTab 
        v-for="(detalle_mov, index) in InfoDetalleMov" 
        :key="index"
      >
        <template #header>
          <div class="accordion-header-premium">
            <div class="header-icon">
              <i class="pi pi-map-marker"></i>
            </div>
            <div class="header-content">
              <h3 class="detalle-title">Detalle {{ index + 1 }}: {{ detalle_mov.remitente_nombre }}</h3>
              <div class="detalle-subtitle">
                <span>{{ detalle_mov.origen_descripcion }} → {{ detalle_mov.destino_descripcion }}</span>
              </div>
            </div>
            <!-- <div class="header-badge">
              <Tag :value="`${new Intl.NumberFormat().format(detalle_mov.peso_final)}Kg`" severity="info" />
            </div> -->
          </div>
        </template>

        <!-- Tabs principales -->
        <TabView class="detalle-tabs-premium">
          <TabPanel header="Detalles">
            <div class="detalle-content-grid">
              <!-- Información del Producto -->
              <Card class="info-card-premium producto">
                <template #title>
                  <div class="card-title-premium">
                    <i class="pi pi-box"></i>
                    <span>PRODUCTO</span>
                  </div>
                </template>
                <template #content>
                  <div class="info-row">
                    <strong>{{ detalle_mov.producto_descripcion }}</strong>
                  </div>
                </template>
              </Card>

              <!-- Peso -->
              <Card class="info-card-premium peso">
                <template #title>
                  <div class="card-title-premium">
                    <i class="pi pi-chart-bar"></i>
                    <span>PESO</span>
                  </div>
                </template>
                <template #content>
                  <div class="metric-display">
                    <div class="metric-value">{{ new Intl.NumberFormat().format(detalle_mov.peso_final) }}</div>
                    <div class="metric-unit">kg</div>
                  </div>
                </template>
              </Card>

              <!-- Unidades -->
              <Card class="info-card-premium unidades">
                <template #title>
                  <div class="card-title-premium">
                    <i class="pi pi-list"></i>
                    <span>UNIDADES</span>
                  </div>
                </template>
                <template #content>
                  <div class="metric-display">
                    <div class="metric-value">{{ detalle_mov.unidades_final }}</div>
                    <div class="metric-unit">unidades</div>
                  </div>
                </template>
              </Card>

              <!-- Empaque -->
              <Card class="info-card-premium empaque">
                <template #title>
                  <div class="card-title-premium">
                    <i class="pi pi-tag"></i>
                    <span>EMPAQUE</span>
                  </div>
                </template>
                <template #content>
                  <div class="info-row">
                    <strong>{{ detalle_mov.empaque_descripcion }}</strong>
                  </div>
                </template>
              </Card>
            </div>

            <!-- Ruta Visual -->
            <div class="route-visual-premium">
              <div class="route-point origin">
                <div class="point-marker">
                  <i class="pi pi-circle-fill"></i>
                </div>
                <div class="point-content">
                  <div class="point-label">ORIGEN</div>
                  <div class="point-name">{{ detalle_mov.origen_descripcion }}</div>
                  <div class="point-address">
                    {{ detalle_mov.remitente_direccion }}<br>
                    {{ detalle_mov.remitente_zona }}
                  </div>
                </div>
              </div>

              <div class="route-line">
                <i class="pi pi-arrow-right"></i>
              </div>

              <div class="route-point destination">
                <div class="point-marker">
                  <i class="pi pi-circle-fill"></i>
                </div>
                <div class="point-content">
                  <div class="point-label">DESTINO</div>
                  <div class="point-name">{{ detalle_mov.destino_descripcion }}</div>
                  <div class="point-address">
                    {{ detalle_mov.destinatario_direccion }}<br>
                    {{ detalle_mov.destinatario_zona }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Ver Mapa de Ruta -->
            <div class="map-toggle-premium">
              <Button 
                :label="showMap==true ? 'Ocultar Mapa' : 'Ver Mapa de Ruta'" 
                :icon="showMap==true ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
                class="p-button-outlined"
                @click="toggleMap(detalle_mov)"
              />
            </div>

            <div v-if="showMap==true" class="map-container-premium">
              	<iframe
					:src="mapUrl"
					width="100%"
					height="450"
					style="border:0;"
					allowfullscreen
					loading="lazy">
				</iframe>
            </div>
          </TabPanel>

          <TabPanel>
			<template #header>
			Eventos Logísticos ({{ detalle_mov.estados.data?.length || 0 }})
			</template>
			<div class="flex">
				<!-- Empty State -->
				<div v-if="detalle_mov.estados.code === 1" class="empty-state-premium">
				<img src="/layout/images/widgets/feature-faq.svg" alt="No hay eventos" />
				<h4>No se encuentran eventos en seway</h4>
				</div>

				<!-- Timeline Horizontal de Eventos -->
				<div v-else class="timeline-horizontal-premium">
				<div class="timeline-track">
					<div 
					v-for="(evento, eventIndex) in detalle_mov.estados.data" 
					:key="eventIndex"
					class="timeline-event"
					:class="getEventoClass(evento.id_events)"
					>
					<div class="event-circle">
						<i :class="getEventoIcon(evento.id_events)"></i>
					</div>
					
					<div class="event-card-premium">
						<div class="event-title">{{ getEventoTitulo(evento.id_events) }}</div>
						<div class="event-date">{{ formatDate(evento.created_at) }}</div>
						
						<div class="event-actions-premium">
						<Button 
							v-if="evento.latitude && evento.longitude"
							label="VER EN MAPA" 
							icon="pi pi-map-marker" 
							class="p-button-sm p-button-outlined"
							@click="openMapModal(evento)"
						/>
						<Button 
							v-if="evento.image_event && evento.image_event.length > 0"
							:label="`VER IMÁGENES (${evento.image_event.length})`" 
							icon="pi pi-image" 
							class="p-button-sm p-button-outlined p-button-warning"
							:loading="loader"
							@click="openGaleriaEventos(evento.image_event)"
						/>
						</div>
					</div>

					<div class="event-connector" v-if="eventIndex < detalle_mov.estados.data.length - 1"></div>
					</div>
				</div>

				<!-- Scroll buttons -->
				<div class="timeline-controls">
					<Button 
					icon="pi pi-chevron-left" 
					class="p-button-rounded p-button-text"
					@click="scrollTimeline('left')"
					/>
					<Button 
					icon="pi pi-chevron-right" 
					class="p-button-rounded p-button-text"
					@click="scrollTimeline('right')"
					/>
				</div>
				</div>
            </div>
          </TabPanel>
        </TabView>
      </AccordionTab>
    </Accordion>

    <!-- Galleria para imágenes -->
    <Galleria 
      :value="img_eventos" 
      :responsiveOptions="galleriaResponsiveOptions" 
      :numVisible="3"
      :circular="true" 
      :fullScreen="true" 
      :showItemNavigators="true" 
      v-model:visible="show_galeria_evnets"
    >
      <template #item="slotProps">
        <img :src="slotProps.item.blob" :alt="slotProps.item.original_url" style="width: 100%; display: block;" />
      </template>
    </Galleria>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loader: false,
      showMap: false,
	  mapUrl: null,
      img_eventos: [],
      show_galeria_evnets: false,
      galleriaResponsiveOptions: [
        { breakpoint: '1024px', numVisible: 5 },
        { breakpoint: '768px', numVisible: 3 },
        { breakpoint: '560px', numVisible: 1 }
      ]
    };
  },
  props: ['InfoDetalleMov', 'info_actores', 'IdCustomer', 'Placa', 'conductor_documento', 'img_vehiculo'],
  methods: {
	toggleMap(detalle_mov) {
		if (this.showMap==true) {
			this.showMap = false;
		}else{
			const origen = encodeURIComponent(detalle_mov.remitente_direccion+' '+detalle_mov.origen_descripcion);
			const destino = encodeURIComponent(detalle_mov.destinatario_direccion+' '+detalle_mov.destino_descripcion);

			this.mapUrl = `https://www.google.com/maps?q=${origen}+to+${destino}&output=embed`;
			this.showMap = true;
		}
		
		
	},
    getEventoClass(id_event) {
      const classes = {
        2: 'llegada', 3: 'carga', 4: 'carga', 5: 'aceptado',
        6: 'llegada', 7: 'descarga', 8: 'descarga', 9: 'aceptado',
        10: 'pendiente', 11: 'exitoso', 12: 'rechazado'
      };
      return classes[id_event] || 'default';
    },
    getEventoIcon(id_event) {
      const icons = {
        2: 'pi-truck', 3: 'pi-box', 4: 'pi-check', 5: 'pi-check-circle',
        6: 'pi-building', 7: 'pi-download', 8: 'pi-check', 9: 'pi-check-circle',
        10: 'pi-clock', 11: 'pi-verified', 12: 'pi-times-circle'
      };
      return `pi ${icons[id_event] || 'pi-circle'}`;
    },
    getEventoTitulo(id_event) {
      const titulos = {
        2: 'LLEGADA AL LUGAR DEL DESCARGUE', 
        3: 'ENTRADA AL LUGAR DEL DESCARGUE',
        4: 'SALIDA DEL LUGAR DEL DESCARGUE',
        5: 'CARGA ACEPTADA',
        6: 'INICIO VIAJE',
        7: 'INICIO DESCARGUE',
        8: 'FIN DESCARGUE',
        9: 'DESCARGA ACEPTADA',
        10: 'ENTREGA PENDIENTE',
        11: 'ENTREGA EXITOSA',
        12: 'ENTREGA RECHAZADA'
      };
      return titulos[id_event] || 'EVENTO';
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString('es-CO', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    },
    scrollTimeline(direction) {
      const timeline = document.querySelector('.timeline-track');
      const scrollAmount = 300;
      if (timeline) {
        timeline.scrollBy({
          left: direction === 'left' ? -scrollAmount : scrollAmount,
          behavior: 'smooth'
        });
      }
    },
    openMapModal(evento) {
      const url = `https://www.google.com.co/maps?q=${evento.latitude},${evento.longitude}`;
      window.open(url, '_blank');
    },
    openGaleriaEventos(imagenes) {
      this.img_eventos = [];
      this.loader = true;
      
      window.api.call('post', 'img_public', {
        imagenes: imagenes,
        nombre_campo_img: 'image_url'
      }).then(response => {
        if (response.status === 200) {
          this.loader = false;
          this.img_eventos = response.data.data.images;
          this.show_galeria_evnets = true;
        }
      }).catch(err => {
        this.loader = false;
        console.error(err);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.detalle-container-premium {
  padding: 0;
}

// Accordion Premium
:deep(.detalles-accordion-premium) {
  .p-accordion-header-link {
    padding: 0;
    border: none;
    background: transparent;
  }

  .p-accordion-tab {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
	margin: 0.5rem 0;
  }

  .p-accordion-content {
    padding: 0;
    border: none;
  }
}

.accordion-header-premium {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
//   background: #ffffff;
  width: 100%;

  .header-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, #0d496b 0%, #0A354E 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.25rem;
    flex-shrink: 0;
  }

  .header-content {
    flex: 1;

    .detalle-title {
      font-size: 1.125rem;
      font-weight: 700;
      color: #1e293b;
      margin: 0 0 0.25rem 0;
    }

    .detalle-subtitle {
      font-size: 0.875rem;
      color: #64748b;
    }
  }

  .header-badge {
    flex-shrink: 0;
  }
}

// Tabs Premium
:deep(.detalle-tabs-premium) {
  .p-tabview-nav {
    background: #f8fafb;
    border: none;
    border-bottom: 2px solid #e2e8f0;
    padding: 0;
  }

  .p-tabview-nav-link {
    border: none;
    background: transparent;
    color: #64748b;
    font-weight: 600;
    font-size: 0.9375rem;
    padding: 1rem 1.5rem;

    &:hover {
      background: transparent;
      color: #1e293b;
    }
  }

  .p-highlight .p-tabview-nav-link {
    color: #1a5f7a;
    border-bottom: 3px solid #1a5f7a;
  }

  .p-tabview-panels {
    background: #ffffff;
  }
}

// Grid de Info Cards
.detalle-content-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.info-card-premium {
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  :deep(.p-card-title) {
    padding: 0.875rem 1rem;
    margin: 0;
    border-bottom: 1px solid #e2e8f0;
  }

  :deep(.p-card-content) {
    padding: 1rem;
  }

  &.producto :deep(.p-card-title) {
    background: #dbeafe;
  }

  &.peso :deep(.p-card-title) {
    background: #d1fae5;
  }

  &.unidades :deep(.p-card-title) {
    background: #fef3c7;
  }

  &.empaque :deep(.p-card-title) {
    background: #f3e8ff;
  }
}

.card-title-premium {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #1e293b;

  i {
    font-size: 1rem;
  }
}

.info-row {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.875rem;
  margin-bottom: 0.75rem;

  &:last-child {
    margin-bottom: 0;
  }

  .label {
    color: #64748b;
    font-weight: 500;
  }
}

.metric-display {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;

  .metric-value {
    font-size: 2rem;
    font-weight: 700;
    color: #1e293b;
    line-height: 1;
  }

  .metric-unit {
    font-size: 0.875rem;
    color: #64748b;
    font-weight: 500;
  }
}

// Ruta Visual
.route-visual-premium {
  display: flex;
  align-items: center;
  gap: 2rem;
  padding: 1.5rem;
  background: #f8fafb;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  margin-bottom: 1.5rem;
}

.route-point {
  flex: 1;
  display: flex;
  gap: 1rem;

  &.origin .point-marker {
    background: linear-gradient(135deg, #10b981, #059669);
  }

  &.destination .point-marker {
    background: linear-gradient(135deg, #ef4444, #dc2626);
  }
}

.point-marker {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.25rem;
  flex-shrink: 0;
}

.point-content {
  flex: 1;
}

.point-label {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #64748b;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}

.point-name {
  font-size: 1rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.5rem;
}

.point-address {
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.5;
}

.route-line {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  color: #94a3b8;
}

// Timeline Horizontal
.timeline-horizontal-premium {
  position: relative;
  width: 100%;
  padding: 2rem 1rem;
  overflow: hidden;
}

.timeline-track {
  display: flex;
  align-items: stretch;
  gap: 2rem;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 1rem 1rem 1rem;
  flex-direction: row;
  flex-wrap: nowrap;
  scroll-behavior: smooth;
  
  // Scrollbar personalizado
  &::-webkit-scrollbar {
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
    
    &:hover {
      background: #94a3b8;
    }
  }
}


.timeline-event {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  min-width: 100px;
  max-width: 280px;
  flex-shrink: 0;

  &.llegada .event-circle {
    background: linear-gradient(135deg, #2e7eff, #4b84ff);
  }

  &.carga .event-circle {
    background: linear-gradient(135deg, rgb(255, 210, 132), rgb(242, 174, 96));
  }

  &.descarga .event-circle {
    background: linear-gradient(135deg, #2e7299, #155e89);
  }

  &.aceptado .event-circle, &.exitoso .event-circle {
    background: linear-gradient(135deg, #36c094, #36c094);
  }

  &.rechazado .event-circle {
    background: linear-gradient(135deg, #ef4444, #dc2626);
  }

  &.pendiente .event-circle {
    background: linear-gradient(135deg, #f59e0b, #d97706);
  }
}

.timeline-track::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 2px;
  background: #e5e7eb;
  transform: translateY(-50%);
  z-index: 0;
}

.event-circle {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.75rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-bottom: 1rem;
  z-index: 2;
}

.event-card-premium {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 1.25rem;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.event-title {
  font-size: 0.875rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.event-date {
  font-size: 0.8125rem;
  color: #64748b;
  margin-bottom: 1rem;
  padding: 0.375rem 0.75rem;
  background: #f8fafb;
  border-radius: 6px;
}

.event-actions-premium {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  :deep(.p-button) {
    font-size: 0.75rem;
    padding: 0.5rem 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    font-weight: 600;
  }
}

.event-connector {
  position: absolute;
  top: 32px;
  left: 100%;
  width: 2rem;
  height: 2px;
  background: linear-gradient(90deg, #cbd5e1, #e2e8f0);
}

.timeline-controls {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  pointer-events: none;
  padding: 0;

  :deep(.p-button) {
    pointer-events: all;
    background: white;
    border: 2px solid #e2e8f0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    &:hover {
      background: #f8fafb;
      border-color: #1a5f7a;
    }
  }
}

// Map Toggle
.map-toggle-premium {
  display: flex;
  justify-content: center;
  margin: 1.5rem 0;
}

.map-container-premium {
  margin-top: 1.5rem;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.leaflet-map {
  height: 500px;
  width: 100%;
}

// Empty State
.empty-state-premium {
  text-align: center;
  padding: 4rem 2rem;

  img {
    max-width: 200px;
    margin-bottom: 1.5rem;
    opacity: 0.6;
  }

  h4 {
    font-size: 1.125rem;
    font-weight: 600;
    color: #64748b;
  }
}

// Responsive
@media (max-width: 768px) {
  .route-visual-premium {
    flex-direction: column;
    gap: 1.5rem;
  }

  .route-line {
    transform: rotate(90deg);
  }

  .detalle-content-grid {
    grid-template-columns: 1fr;
  }

  .timeline-event {
    min-width: 240px;
  }

  .event-circle {
    width: 56px;
    height: 56px;
    font-size: 1.5rem;
  }
}
</style>